import React, { createContext, useContext, useState, useMemo } from 'react';

const MovimientosContext = createContext();

export const MovimientosProvider = ({ children }) => {
  const [selectedCliente, setSelectedCliente] = useState(null);
  const [articulosMovimientos, setArticulosMovimientos] = useState([]);
  // Estructura:
  // [{
  //   articulo: {_id, nombre, ...},
  //   posiciones: [
  //     { posicion: "A-1-1", cantidad: 100, lote: "L001" | null, fechaVencimiento: "YYYY-MM-DD" | null }
  //   ]
  // }]

  const addArticuloMovimiento = (articulo) => {
    setArticulosMovimientos(prev => {
      const exists = prev.some(item => item.articulo._id === articulo._id);
      if (!exists) return [...prev, { articulo, posiciones: [] }];
      return prev;
    });
  };

  /**
   * Agrega una posición a un artículo. Si ya existe misma combinación
   * (posicion + lote + fechaVencimiento), suma cantidades; si no, agrega línea.
   * @param {string} articuloId
   * @param {string} posicion Ej: "A-1-1"
   * @param {number} cantidad
   * @param {{lote?: string|null, fechaVencimiento?: string|null}} extra
   */
  const addPosicionToArticulo = (articuloId, posicion, cantidad, extra = {}) => {
    const lote = extra?.lote ?? null;
    const fechaVencimiento = extra?.fechaVencimiento ?? null;

    setArticulosMovimientos(prev => {
      const next = prev.map(item => {
        if (item.articulo._id !== articuloId) return item;

        // Buscar línea existente con misma combinación
        const idx = item.posiciones.findIndex(p =>
          p.posicion === posicion &&
          (p.lote || null) === (lote || null) &&
          (p.fechaVencimiento || null) === (fechaVencimiento || null)
        );

        if (idx > -1) {
          const copyPos = [...item.posiciones];
          copyPos[idx] = {
            ...copyPos[idx],
            cantidad: Number(copyPos[idx].cantidad || 0) + Number(cantidad || 0),
          };
          return { ...item, posiciones: copyPos };
        }

        return {
          ...item,
          posiciones: [
            ...item.posiciones,
            { posicion, cantidad: Number(cantidad || 0), lote, fechaVencimiento }
          ]
        };
      });
      return next;
    });
  };

  const removeArticuloMovimiento = (articuloId) => {
    setArticulosMovimientos(prev =>
      prev.filter(item => item.articulo._id !== articuloId)
    );
  };

  const clearMovimientos = () => {
    setArticulosMovimientos([]);
    setSelectedCliente(null);
  };

  const value = useMemo(() => ({
    selectedCliente,
    setSelectedCliente,
    articulosMovimientos,
    addArticuloMovimiento,
    addPosicionToArticulo,
    removeArticuloMovimiento,
    clearMovimientos
  }), [selectedCliente, articulosMovimientos]);

  return (
    <MovimientosContext.Provider value={value}>
      {children}
    </MovimientosContext.Provider>
  );
};

export const useMovimientos = () => useContext(MovimientosContext);